import TransitDetails from './TransitDetails.jsx';
import './TransitDetails.css';

export default TransitDetails;
